import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import SetupPage from './pages/SetupPage';
import MeetingsPage from './pages/MeetingsPage';
import MeetingDetailPage from './pages/MeetingDetailPage';
import NeueMeetingPage from './pages/NeueMeetingPage';
import AdminPage from './pages/AdminPage';

function Protected({ children }) {
  return localStorage.getItem('meetingnotes_token') ? children : <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/setup" element={<SetupPage />} />
        <Route path="/" element={<Protected><MeetingsPage /></Protected>} />
        <Route path="/meeting/:id" element={<Protected><MeetingDetailPage /></Protected>} />
        <Route path="/neu" element={<Protected><NeueMeetingPage /></Protected>} />
        <Route path="/admin" element={<Protected><AdminPage /></Protected>} />
      </Routes>
    </BrowserRouter>
  );
}
